function cov_27j5siwg7g() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BedroomFilled.tsx";
  var hash = "40cfb058f15b1db93425a13d1cfff538950c9135";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BedroomFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "40cfb058f15b1db93425a13d1cfff538950c9135"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27j5siwg7g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27j5siwg7g();
var Icon = (cov_27j5siwg7g().s[0]++, {
  name: 'bedroom-filled',
  svg: "<path d=\"M3.59409 2.25C2.7137 2.25 2 2.9637 2 3.84409V20.7168C2 21.4072 2.55964 21.9668 3.25 21.9668C3.94036 21.9668 4.5 21.4072 4.5 20.7168V17.4668H19.5V20.6211C19.5 21.3114 20.0596 21.8711 20.75 21.8711C21.4404 21.8711 22 21.3114 22 20.6211V15.1211C22 13.5567 21.3786 12.0564 20.2724 10.9503C19.1662 9.8441 17.6659 9.22266 16.1016 9.22266H9.41406V8.06997C9.41406 4.85569 6.80837 2.25 3.59409 2.25Z\" fill=\"currentColor\"/>"
});
export default Icon;